import React, { useState } from 'react';
import { Inventory, InventoryItem, Variation, VariationItem } from '../../../@types/inventory';
import { SubtractSquareIcon } from '../../../assets/icons/SubtractSquareIcon';
import { VariationTable } from './VariationTable';
import { InputComponent } from '../../core/Forms';
import { Input } from 'postcss';
import { formatMoney } from '../../../utils';
import { convertToFloat } from '../../../utils/convertToFloat';
import { commasToNumber } from '../../../utils/convertToFloat';

interface InventoryTableProps {
  inventory: InventoryItem;
  setInventories: (inventories: InventoryItem) => void;
  variations: VariationItem[];
  setVariations: (Variations: VariationItem[]) => void;
  error: any;
  variationList: any;
}

function InventoryTable({
  inventory,
  setInventories,
  variations,
  setVariations,
  error,
  variationList,
}: InventoryTableProps) {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;

    if (name == 'quantity') {
      const numericValue = value.replace(/\D/g, '');
      const updatedInventory = { ...inventory, [name]: numericValue };
      setInventories(updatedInventory);
    }

    if (name == 'name' || name === 'description') {
      const updatedInventory = { ...inventory, [e.target.name]: e.target.value };
      setInventories(updatedInventory);
    }

    if (name === 'rate' || name === 'costPrice') {
      const resValue = commasToNumber(value);
      const updatedInventory = { ...inventory, [e.target.name]: resValue };
      setInventories(updatedInventory);
    }
  };

  const handleAddVariation = (newVariation: any) => {
    setVariations([...variations, newVariation]);
  };

  const handleRemoveVariation = (id: number) => {
    const updatedVariations = variations.filter((variation, index) => index !== id);
    setVariations(updatedVariations);
  };

  const handleUpdateVariation = (id: number, field: string, value: string) => {
    const updatedVariations = variations.map((variation, index) => {
      if (index === id) {
        if (field === 'costPrice' || field === 'price') {
          const varVal = commasToNumber(value);
          return { ...variation, [field]: varVal };
        } else if (field === 'quantity') {
          const numericValue = value.replace(/\D/g, '');
          return { ...variation, [field]: numericValue };
        } else {
          return { ...variation, [field]: value };
        }
      }
      return variation;
    });
    setVariations(updatedVariations);
  };

  return (
    <div className="mt-8">
      <form>
        <div className="lg:flex lg:gap-6 mb-6 ">
          <div className="w-full lg:w-1/2">
            <label className="block text-[#212121] tracking-wide text-[14px] font-normal mb-2" htmlFor="product-name">
              Inventory Name
            </label>
            <InputComponent
              className="block w-full border-[0.5px] border-[#A4A4A4] rounded py-3 px-4"
              type="text"
              name="name"
              placeholder="Product Name"
              value={inventory.name}
              handleChange={handleInputChange}
              error={error.name}
            />
          </div>
          <div className="hidden lg:block w-1/2">
            <label className="block text-[#212121] tracking-wide text-[14px] font-normal mb-2" htmlFor="quantity">
              Quantity
            </label>
            <InputComponent
              className="block w-full border-[0.5px] border-[#A4A4A4] rounded py-3 px-4"
              type="text"
              name="quantity"
              placeholder="Quantity"
              value={inventory.quantity}
              handleChange={handleInputChange}
              error={error.quantity}
            />
          </div>
        </div>
        <div className="flex gap-6 mb-6">
          <div className="w-full">
            <label className="block text-[#212121] tracking-wide text-[14px] font-normal " htmlFor="cost-price">
              Cost Price
            </label>
            <InputComponent
              className="block w-full border-[0.5px] border-[#A4A4A4] rounded py-3 px-4"
              type="text"
              placeholder={`${formatMoney(0.0, 'NGN')}`}
              name="costPrice"
              value={inventory.costPrice}
              handleChange={handleInputChange}
              error={error.costPrice}
            />
          </div>
          <div className="w-full">
            <label className="block text-[#212121] tracking-wide text-[14px] font-normal" htmlFor="selling-price">
              Selling Price
            </label>
            <InputComponent
              className="block w-full border-[0.5px] border-[#A4A4A4] rounded py-3 px-4"
              type="text"
              name="rate"
              placeholder={`${formatMoney(0.0, 'NGN')}`}
              value={inventory?.rate}
              handleChange={handleInputChange}
              error={error.rate}
            />
          </div>
        </div>
        <div className="mb-6 lg:hidden">
          <label className="block text-[#212121] tracking-wide text-[14px] font-normal" htmlFor="grid-first-name">
            Quantity
          </label>
          <InputComponent
            className="block w-full border-[0.5px] border-[#A4A4A4] rounded py-3 px-4"
            type="text"
            name="quantity"
            placeholder="Quantity"
            value={inventory.quantity}
            handleChange={handleInputChange}
            error={error.quantity}
          />
        </div>
        <div className="mb-6 md:mb-0">
          <label className="block text-[#212121] tracking-wide text-[14px] font-normal" htmlFor="grid-first-name">
            Description
          </label>
          <textarea
            className="block w-full border-[0.5px] border-[#A4A4A4] h-[80px] md:h-[140px] rounded"
            id="grid-first-name"
            name="description"
            placeholder="Provide more details about the product.."
            value={inventory.description}
            onChange={handleInputChange}
          />
        </div>
      </form>
      <div className="xl:mt-[-1em]">
        <VariationTable
          variationList={variationList}
          onAddVariation={handleAddVariation}
          variations={variations}
          onRemoveVariation={handleRemoveVariation}
          onUpdateVariation={handleUpdateVariation}
        />
      </div>
    </div>
  );
}

export { InventoryTable };
